import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
Vue.use(BootstrapVue);

import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";

import { SpinnerPlugin } from "bootstrap-vue";
Vue.use(SpinnerPlugin);

Vue.component("v-icon", Icon);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
